import { useMemo } from "react";

import type { LabelDictionaries } from "src/analytics/metrics/VisualizeMetrics/specialDomainScaling";
import { useFlows } from "src/api/queries";

// UUID→name map for the `flow_id` special domain, so charts in the workspace
// copilot render flow names on axes, legends and tooltips. The flow realm's
// equivalent resolves only the one flow it is scoped to; this one covers every
// flow in the workspace, which is what a cross-flow chart needs.
//
// The prompt tells the agent to keep `flow_id` as the series column and never
// translate it in SQL. That instruction is only honest while this dictionary is
// populated — an empty one leaves raw UUIDs on the axis.
export const useWorkspaceSpecialDomainLabels = (
  wsId: string,
): LabelDictionaries => {
  const { data: flows } = useFlows({ workspaceId: wsId });

  return useMemo<LabelDictionaries>(
    () => ({
      flow_id: Object.fromEntries(flows.map((flow) => [flow.id, flow.name])),
    }),
    [flows],
  );
};
